module.exports = __webpack_public_path__ + "static/img/empty_data.78a41ca8.png";